//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'


export default {
    data() {
            return {
                commend: null,
                isClick: false,
                isShowMore: false,
                isShowMask: false,
                swiperOption: {
                    pagination: '.swiper-pagination',
                    slidesPerView: 5,
                    paginationClickable: true,
                    spaceBetween: 12,
                    freeMode: true
                },
                isShowPlay:false,
                hash:null
            }
        },
        mounted() {
            axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com?json=true')
                .then((response) => {
                    this.commend = response.data.data.splice(6, 5);
                    console.log(this.commend);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        methods: {
            showMore() {
                this.isShowMore = !this.isShowMore;
                this.isShowMask = !this.isShowMask;
            },
            hide() {
                this.isShowMore = false;
                this.isShowMask = false;
            },
            showPlay(num){
                var arr = document.getElementsByTagName('img');
                console.log(arr);
                //console.log(this.commend[num-10]);
                var songList = [this.commend[num-10]];
                this.$store.dispatch('setImg', [arr[num+1].currentSrc,true]);
                this.$store.dispatch('setSongs',songList);
            }
        },
        filters: {
            shortTitle(input) {
                if (input.length > 10) {
                    return input.slice(0, 10) + '...';
                } else {
                    return input
                }
            }
        }
}



// WEBPACK FOOTER //
// ./src/components/xcommend.vue